'use client';

// A simple right-side slide-over panel. Self-contained: only React +
// lucide-react + tailwind. Used by the Invite and Member-edit flows.

import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

export const Drawer = ({ open, onClose, title, subtitle, children, footer, testId }) => {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (open) {
      const id = requestAnimationFrame(() => setShown(true));
      return () => cancelAnimationFrame(id);
    }
    setShown(false);
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50" data-testid={testId}>
      <div
        className={`absolute inset-0 bg-black/40 transition-opacity duration-200 ${
          shown ? "opacity-100" : "opacity-0"
        }`}
        onClick={onClose}
      />
      <div
        className={`absolute inset-y-0 right-0 flex w-full max-w-md flex-col bg-white shadow-xl transition-transform duration-200 ${
          shown ? "tranzinc-x-0" : "tranzinc-x-full"
        }`}
      >
        <div className="flex items-start justify-between border-b border-zinc-200 px-5 py-4">
          <div className="min-w-0">
            <h2 className="truncate text-base font-semibold text-zinc-900">{title}</h2>
            {subtitle && <p className="mt-0.5 truncate text-xs text-zinc-500">{subtitle}</p>}
          </div>
          <button
            type="button"
            data-testid="drawer-close"
            onClick={onClose}
            className="ml-3 shrink-0 rounded-md p-1 text-zinc-500 hover:bg-zinc-100"
          >
            <X size={18} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-5">{children}</div>
        {footer && <div className="border-t border-zinc-200 px-5 py-4">{footer}</div>}
      </div>
    </div>
  );
};
